//500

// Used to catch any other errors - not server-side.

export class APIError extends Error {
  constructor(kind, hostname, message, type, extensionKey) {
    super(`${kind}: ${message}`);
    this.kind = kind;
    this.hostname = hostname;
    this.message = message;
    this.type = type;
    this.extensionKey = extensionKey;
    this.name = 'APIError';
    // The error type received from the server.
    this.type = type;
    // The kind mapped to on the client.
    this.kind = kind;
    // The message received from the server.
    this.message = message;
    // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
    this.hostname = hostname;
    // The extensionKey passed from the error response from ORS
    this.extensionKey = extensionKey;
  }
}